import React, { useState } from 'react';
import FileUpload from './components/FileUpload';
import SummaryCard from './components/SummaryCard';
import './App.css';

function App() {
  const [wrappedData, setWrappedData] = useState(null);

  const handleDataReceived = (data) => {
    setWrappedData(data);
  };

  return (
    <div className="App">
      <header className="App-header">
        {/* <h1>Netflix Recap</h1> */}
      </header>
      <main>
        {!wrappedData ? (
          <FileUpload onDataReceived={handleDataReceived} />
        ) : (
          <SummaryCard data={wrappedData} />
        )}
      </main>
    </div>
  );
}

export default App;
